import React from "react";

export interface ConfirmRestartSetProps {
	result: {
		canRestart: boolean;
		isCurrentSet: boolean;
	};
}

export const ConfirmRestartSet: React.FC<ConfirmRestartSetProps> = ({
	result,
}) => {
	if (result.canRestart) {
		return (
			<>
				{"Are you sure you want to restart this problem set?\n" +
					"You will " +
					(result.isCurrentSet
						? ""
						: "be moved to the newest version of these problems and ") +
					"no longer be able to see the work you've done so far."}
			</>
		);
	} else {
		return (
			<>
				{`You are currently on an outdated problem set that is no longer part of this lesson.
    Use "Switch Problem Set" to choose a current problem set for this lesson.`}
			</>
		);
	}
};
